// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pxInput_RPfDy.win_Tqk4k {
  width : 42px;
  min-width : unset;
  text-align: right;
}

.popup_SQVGp.win_Tqk4k {
  min-width : unset;
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-attributes/lib/detail/customText/textEditor/editors/widgets/FontSizeSelector.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".pxInput.win {\n  width : 42px;\n  min-width : unset;\n  text-align: right;\n}\n\n.popup.win {\n  min-width : unset;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pxInput": `pxInput_RPfDy`,
	"win": `win_Tqk4k`,
	"popup": `popup_SQVGp`
};
export default ___CSS_LOADER_EXPORT___;
